
import { Team } from "@/types"
import { Component, Vue, Watch, Prop } from "vue-property-decorator"

import DataTable from "../DataTable.vue"

import { Folder, FolderType } from "@/types/folder"
import api from "@/services/api"

@Component({
	components: {
		"data-table": DataTable
	}
})
export default class FolderSetup extends Vue {
	@Prop({ default: () => [] })
	value!: Folder[]

	@Prop({ default: FolderType.Insight })
	folderType!: FolderType

	@Prop({ default: () => [] })
	teams!: Team[];

	@Prop({ default: false })
	hide!: boolean;

	private get folderColumns () {
		return [
			{
				key: "title",
				label: "Title",
				sortable: true,
				errors: (item: any) => (item.title
					? (this.value.some(folder => folder.title === item.title) && !item.id ? "Folder name already in use" : null)
					: "Please enter a title")
			},
			{
				key: "teams",
				hasTemplate: true,
				label: "Teams",
				dataType: "list-multiple",
				valueColumn: "teams",
				options: this.teams
			}
		]
	}

	private get teamsById (): { [key: string]: Team } {
		return this.teams.toDictionary("id")
	}

	private async saveFolder (folder: Folder) {
		const updatedFolder = await api.folderSet(folder)

		if (folder.id) {
			const folderIndex = this.value.findIndex(f => f.id === folder.id)
			if (folderIndex === -1) {
				// In case we can't find the folder we're updating in the list, just refresh the whole list
				this.$emit("refreshFolders")
			} else {
				this.value.splice(folderIndex, 1, updatedFolder)
			}
		} else {
			const existingIndex = this.value.findIndex(f => f.title === folder.title)
			if (existingIndex > -1) {
				this.value.splice(existingIndex, 1, updatedFolder)
			} else {
				this.value.push(updatedFolder)
			}
		}

		this.value = this.value.sortBy("title")

		this.$emit("refreshFolders")
		this.$emit("input", this.value)
	}

	private createFolder () {
		return { id: null, title: "", teams: [], folderType: this.folderType }
	}

	private async deleteFolder (folder: Folder) {
		if (!folder.id) return

		await api.folderDelete(folder)
		this.value.removeWhere(f => f.id === folder.id)
		this.$emit("input", this.value)
		this.$emit("folderDeleted", folder)
	}

	private async folderUsage (folder: Folder): Promise<{ id: string, label: string }[]> {
		return api.folderUsage(folder)
	}
}

